module.exports = __webpack_public_path__ + "static/media/logo_black.e34a6987.png";